import { formatInTimeZone } from 'date-fns-tz';

/**
 * Format a date in the local timezone
 * @param date - The date to format
 * @param fmt - The format string (date-fns format)
 * @returns A formatted date string
 */
export const formatLocalDate = (date: Date, fmt: string) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  try {
    return formatInTimeZone(date, timeZone, fmt);
  } catch (e: any | Error) {
    return e.message;
  }
};

/**
 * Formats a date as YYYY-MM-DD for CSV export (standard ISO format).
 * This format is universally recognized by spreadsheet applications and doesn't require escaping.
 * Uses UTC methods to ensure consistent output regardless of local timezone.
 *
 * @param date - The date to format
 * @returns A string in YYYY-MM-DD format
 */
export const formatDateForCsv = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
